import { Platform } from 'react-native'
import { check, PERMISSIONS, request, RESULTS } from 'react-native-permissions'

type MicrophonePermissionResult = {
  granted: boolean
  blocked: boolean
}

const MICROPHONE_PERMISSION = Platform.select({
  ios: PERMISSIONS.IOS.MICROPHONE,
  android: PERMISSIONS.ANDROID.RECORD_AUDIO,
})

const isGranted = (status: string) => status === RESULTS.GRANTED || status === RESULTS.LIMITED

export const ensureMicrophonePermission = async (): Promise<MicrophonePermissionResult> => {
  if (!MICROPHONE_PERMISSION) {
    return { granted: false, blocked: false }
  }

  const currentStatus = await check(MICROPHONE_PERMISSION)
  if (isGranted(currentStatus)) {
    return { granted: true, blocked: false }
  }

  if (currentStatus === RESULTS.BLOCKED) {
    return { granted: false, blocked: true }
  }

  if (currentStatus === RESULTS.DENIED) {
    const requestedStatus = await request(MICROPHONE_PERMISSION)
    if (isGranted(requestedStatus)) {
      return { granted: true, blocked: false }
    }

    return { granted: false, blocked: requestedStatus === RESULTS.BLOCKED }
  }

  return { granted: false, blocked: false }
}
